class CustomQuiz extends HTMLElement {
    constructor() {
        super();
        this.size = parseInt(this.dataset.size);
        this.firstStep = this.querySelector('.step.active');
        this.questions = this.querySelectorAll('.question');
        this.allResult = this.querySelectorAll('.result');
        this.nextBtns = this.querySelectorAll('.btn-answer');
        this.prevBtns = this.querySelectorAll('.btn-prev');
        this.progressBar = this.querySelector('.quiz-progress-bar');
        this.resetBtn = this.querySelector('.btn-reset');
        this.resultsWrap = this.querySelector('.quiz-results');
        this.form = this.querySelector('form');
        this.submitBtn = this.form.querySelector('button[type=button]');
        this.input = this.form.querySelector('input');
        this.updateProgressBar(1);

        this.nextBtns?.forEach( btn => btn.addEventListener('click', this.onNextQuestion.bind(this)));
        this.prevBtns?.forEach( btn => btn.addEventListener('click', this.onPrevQuestion.bind(this)));
        this.resetBtn?.addEventListener('click', this.onReset.bind(this));
        this.form && this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
        if (this.form && this.input) {
            this.form.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                e.preventDefault();
                this.onSubmit(e);
                }
            });
        }
    }
    onSubmit(e) {
        e.preventDefault();
        if (!this.form.checkValidity()) {
            this.form.reportValidity();
            return
        }
        const formData = new FormData(this.form);
        const str = this.createQuizNote();
        formData.set('contact[note]', str);
        const body = new URLSearchParams(formData).toString();

        fetch(`${this.form.getAttribute('action')}`, {
            method:"POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'text/html,application/xhtml+xml',
            },
            body:body
        }).then(response => {
            return response.text();
        })

        const cartForm = new FormData();
        const objCartAttribute = this.createCartAttribute();
        for (const [key, value] of Object.entries(objCartAttribute)) {
            cartForm.append(`attributes[${key}]`, value);
        }
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method:'post',
            body: cartForm
        }).then(res => {
            return res.json();
        }).then(() => {
           this.onNextQuestion(e);
        });

    }
    createCartAttribute() {
        const obj = {};
        Array.from(this.querySelectorAll('input:checked')).forEach( input => {
            const question = input.dataset.question;
            const val = input.value;
            obj[question] = val
        });
        
        return obj
    }
    createQuizNote() {
        const str = Array.from(this.querySelectorAll('input:checked')).map(input => `${input.dataset.question}:${input.value}`).join('\n');

        return str
    }

    onNextQuestion(e) {
        const target = e.target;

        if(!target) return;

        const currentStep = target.closest('.step');
        const nextStep = currentStep.nextElementSibling;
        const indexNextStep = parseInt(nextStep.dataset.index);

        currentStep.classList.remove('active');
        nextStep.classList.add('active');

        this.updateProgressBar(indexNextStep);

        if(!nextStep.nextElementSibling) {
            this.validResult();
        }
        
    }
    onPrevQuestion(e) {
        const target = e.target;
        const currentStep = target.closest('.step');
        const prevStep = currentStep.previousElementSibling;
        const indexPrevStep = parseInt(prevStep.dataset.index);

        this.updateProgressBar(indexPrevStep);

        currentStep.classList.remove('active');
        prevStep.classList.add('active');

    }
    onReset() {
        this.hideAllResult();
        this.resultsWrap.classList.remove('active');
        this.firstStep.classList.add('active');
        this.updateProgressBar(1);
    }
    validResult() {
        this.hideAllResult();

        const requiredAnswers = Array.from(this.querySelectorAll('.question-include')).filter( question => question.querySelector('input:checked')).map(question => question.querySelector('input:checked').value);
        const resultsAll = Array.from(this.allResult).map(result => ({ element: result, values: result.dataset.result.split('/')}));
        const resultFind = resultsAll.find( ({ values }) => values.every(value => requiredAnswers.includes(value)));

        if(resultFind) {
            resultFind.element?.classList.add('active');
        }else {
            resultsAll[0]?.element.classList.add('active');
        }
    }

    hideAllResult() {
        this.allResult.forEach(result => result.classList.remove('active'));
    }

    updateProgressBar(index) {
        if(!this.progressBar) return

        const percent = index / this.size * 100;

        this.progressBar.style.setProperty('--progress-width', `${percent}%`);
    }
}

customElements.define('custom-quiz', CustomQuiz);

